<template>
  <div class="home color-white a98b59-bg">
    <div class="HomeConter w100">
      <div class="HomeConter-title shadow2 w100 a98b59-color">
        EXECUTIVE CONDOMINIUM, REDEFINED.
      </div>
      <div class="ImageTitle font12" >ARTIST’S IMPRESSION</div>
    </div>
    <div class="a98b59-bg">
      <div
        class="w60"
        style="margin: auto; padding-top: 85px; padding-bottom: 100px"
      >
        <p class="Initial font21 lh30 lt1">
          Once in a rare while comes an EC of this calibre. Novo Place raises
          every expectation of a luxury EC, and elevates living to new levels of
          luxury and comfort.
        </p>
        <p class="font21 lh30 p-btm-20">Welcome home.</p>
        <div class="flex-center relative"
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave"
        >
          <!-- <img class="img-initial" src="@/assets/home/home-video.png" alt="" /> -->
          <video
            ref="video"
            playsinline
            @play="playType = false"
            @pause="playType = true"
            @ended="playType = true"
            poster="@/assets/video/WelcomeVideo-pg.png"
            class="img-initial"
            src="@/assets/video/video3.mp4"
          ></video>
          <div v-if="playType || (!playType && mouseType)" class="controls">
            <button @click="rewind">
              <svg t="1730445007352" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5506" width="32" height="32"><path d="M981.333333 223.722667v570.197333c0 47.082667-33.28 66.496-74.346666 43.221333L401.984 550.976c-41.045333-23.253333-41.066667-61.013333 0-84.266667L906.986667 180.501333C948.010667 157.269333 981.333333 176.597333 981.333333 223.722667z m-558.293333 280.106666a41.173333 41.173333 0 0 0-7.232 4.992c1.706667 1.536 4.074667 3.242667 7.210667 5.034667L928.021333 800c12.608 7.146667 10.645333 8.32 10.645334-6.101333V223.722667c0-14.4 1.984-13.226667-10.666667-6.08L423.04 503.808z m195.989333-247.381333l-0.042666-9.045333c-0.106667-30.784-15.893333-39.914667-42.709334-24.725334L106.709333 488.768c-26.602667 15.061333-26.602667 31.957333 0 47.018667l469.546667 266.090666c26.794667 15.168 42.538667 5.973333 42.624-24.874666v-8.682667a21.333333 21.333333 0 1 1 42.666667 0.106667v8.682666c-0.149333 63.466667-51.093333 93.162667-106.304 61.866667L85.674667 572.928c-55.445333-31.402667-55.445333-89.856 0-121.258667l469.546666-266.090666c55.210667-31.274667 106.197333-1.728 106.453334 61.674666v9.045334a21.333333 21.333333 0 1 1-42.666667 0.170666z" fill="#ffffff" p-id="5507"></path></svg>
            </button>
            <button v-if="playType" @click="play">
              <svg t="1730444951954" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4795" width="32" height="32"><path d="M675.328 117.717333A425.429333 425.429333 0 0 0 512 85.333333C276.352 85.333333 85.333333 276.352 85.333333 512s191.018667 426.666667 426.666667 426.666667 426.666667-191.018667 426.666667-426.666667c0-56.746667-11.093333-112-32.384-163.328a21.333333 21.333333 0 0 0-39.402667 16.341333A382.762667 382.762667 0 0 1 896 512c0 212.074667-171.925333 384-384 384S128 724.074667 128 512 299.925333 128 512 128c51.114667 0 100.8 9.984 146.986667 29.12a21.333333 21.333333 0 0 0 16.341333-39.402667zM456.704 305.92C432.704 289.152 405.333333 303.082667 405.333333 331.797333v360.533334c0 28.586667 27.541333 42.538667 51.370667 25.856l252.352-176.768c21.76-15.253333 21.632-43.541333 0-58.709334l-252.373333-176.768z m-8.597333 366.72V351.466667l229.269333 160.597333-229.269333 160.597333z" fill="#ffffff" p-id="4796"></path></svg>
            </button>
            <button v-else @click="pause">
              <svg t="1730444977832" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5016" width="32" height="32"><path d="M128 106.858667C128 94.976 137.621333 85.333333 149.12 85.333333h85.76c11.648 0 21.12 9.6 21.12 21.525334V917.12c0 11.882667-9.621333 21.525333-21.12 21.525333H149.12A21.290667 21.290667 0 0 1 128 917.141333V106.88z m640 0c0-11.882667 9.621333-21.525333 21.12-21.525334h85.76c11.648 0 21.12 9.6 21.12 21.525334V917.12c0 11.882667-9.621333 21.525333-21.12 21.525333h-85.76a21.290667 21.290667 0 0 1-21.12-21.525333V106.88z" fill="#ffffff" p-id="5017"></path></svg>
            </button>
            <button @click="fastForward">
              <svg t="1730444993588" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5237" width="32" height="32"><path d="M600.96 503.808L96 217.642667c-12.650667-7.168-10.666667-8.32-10.666667 6.08v570.197333c0 14.4-1.962667 13.248 10.666667 6.101333l504.96-286.165333c3.157333-1.792 5.546667-3.498667 7.232-5.034667a41.173333 41.173333 0 0 0-7.210667-5.013333zM42.666667 223.722667c0-47.146667 33.322667-66.453333 74.346666-43.2l505.002667 286.165333c41.066667 23.274667 41.045333 61.013333 0 84.266667L117.013333 837.162667C75.946667 860.416 42.666667 841.002667 42.666667 793.92V223.722667z m362.304 32.725333a21.333333 21.333333 0 1 1-42.666667-0.170667l0.042667-9.045333c0.234667-63.402667 51.221333-92.949333 106.410666-61.653333L938.325333 451.626667c55.445333 31.402667 55.445333 89.856 0 121.258666l-469.546666 266.090667c-55.232 31.274667-106.176 1.578667-106.325334-61.888v-8.682667a21.333333 21.333333 0 1 1 42.666667-0.106666v8.682666c0.085333 30.869333 15.829333 40.042667 42.602667 24.874667l469.568-266.090667c26.602667-15.061333 26.602667-31.957333 0-47.018666l-469.546667-266.090667c-26.837333-15.189333-42.624-6.058667-42.730667 24.725333l-0.042666 9.045334z" fill="#ffffff" p-id="5238"></path></svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="Introduce w100 relative">
      <img
        class="w100 absolute"
        style="left: 0px; top: -8vh"
        src="@/assets/208/line2.png"
        alt=""
      />
      <div class="IntroduceConter">
        <div class="textEnd" style="width: 32%">
          <h2 class="a98b59-color info-title">PRIME LOCATION</h2>
          <p class="info-text">
            Enjoy all the positives of living in Singapore’s 
first smart and sustainable town. And all 
the possibilities of a vibrant revitalised 
Jurong a short drive away.
          </p>
        </div>
        <div class="img-content">
          <img src="@/assets/208/1.png" alt="" />
          <p class="right">
            ARTIST’S IMPRESSION OF TENGAH © HOUSING & DEVELOPMENT BOARD
          </p>
          <!-- <div class="corner-crop"></div> -->
        </div>
      </div>
      <div class="IntroduceConter right-type">
        <div class="textStart" style="width: 32%">
          <h2 class="a98b59-color info-title">UNSURPASSED <div class="phone-LineBreak"></div> CONVENIENCE</h2>
          <p class="info-text">
            In Tengah’s serene Plantation District, 
Novo Place is a verdant oasis of contemporary 
luxury, just a four-minute walk to the upcoming 
Tengah Park MRT station on the future 
Jurong Region Line. And a mere three MRT 
stops to Jurong East, with easy access to 
the Pan Island Expressway (PIE).
          </p>
        </div>
        <div class="img-content">
          <img src="@/assets/208/2.png" alt="" />
          <p class="right">FOR ILLUSTRATION ONLY</p>
        </div>
      </div>
      <div class="IntroduceConter right-type">
        <div class="textStart" style="width: 32%">
          <h2 class="a98b59-color info-title">AMENITIES ALL ROUND</h2>
          <p class="info-text">
            Great shopping and dining nearby with Jem 
and Westgate just three MRT stops away, and 
Plantation Plaza four minutes’ drive away with 
Koufu and Giant for your everyday needs.
          </p>
        </div>
        <div class="img-content">
          <img src="@/assets/208/3.png" alt="" />
          <p class="right">FOR ILLUSTRATION ONLY</p>
          <div class="corner-crop-1"></div>
        </div>
      </div>
      <div class="IntroduceConter">
        <div class="textEnd" style="width: 32%">
          <h2 class="a98b59-color info-title">EXCEPTIONAL FACILITIES</h2>
          <p class="info-text">
            At Novo Place, you’re surrounded by beautiful 
greenery and every amenity you could wish for. 
From four pools, a stunning Clubhouse, 
Gymnasium, Kids’ Party Room, four BBQ 
Pavilions to all-day Library and Work Lounge.
          </p>
        </div>
        <div class="img-content">
          <img src="@/assets/208/4.png" alt="" />
          <p class="right">50M LAP POOL | ARTIST’S IMPRESSION</p>
        </div>
      </div>
    </div>
    <div class="img-content" style="width: 100%">
      <img src="@/assets/home/_Novo RDR_Aerial View_RGB_lr.jpg" alt="" />
      <p style="right: 0">
        ARTIST'S IMPRESSION
      </p>
    </div>
    <div class="a98b59-bg f500 p-btm-50 p-top-50 lt2">
      <p class="Initial font21 m-btm-20">LIVE THE LUSH LIFE</p>
      <p class="Initial font21">ON A WHOLE NEW LEVEL.</p>
    </div>
    <div class="a98b59-bg w100 p-btm-50 p-top-50">
    <div class="CONSTRUCTION-PROGRESS">
        <div class="CONSTRUCTION-PROGRESS-title">
            <div style="margin-left: 20px;">CONSTRUCTION PROGRESS</div>
            <div style="width: 20%;text-align: start;text-indent: 1vw;">STATUS</div>
        </div>
        <div v-for="value in CONSTRUCTIONPROGRESS" :key="value" class="CONSTRUCTION-PROGRESS-content">
            <div style="margin-left: 20px;flex: 1;">{{value.title}}</div>
            <div class="CONSTRUCTION-PROGRESS-status">
                <div v-if="value.type==1" class="status1"></div>
                <div v-if="value.type==2" class="status2"></div>
                <div v-if="value.type==0" class="status3"></div>
                <span>{{ value.status }}</span>
            </div>

        </div>
        <div class="CONSTRUCTION-PROGRESS-content" style="border: 0;margin-left: 20px;">
          *Estimated date is subject to change.
        </div>
      </div>
    </div>
    <contant />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import contant from "@/components/contant.vue";

export default {
  components: {
    Footer,
    contant,
  },
  data() {
    return {
      playType:true,
      mouseType:false,
      CONSTRUCTIONPROGRESS:[
        {title:'FOUNDATION WORKS (INCL. PILE CAPS)',status:'COMPLETED',type:1},
        {title:'REINFORCED CONCRETE FRAMEWORK',status:'COMPLETED',type:1},
        {title:'PARTITION WALLS',status:'COMPLETED',type:1},
        {title:'CEILING (INCL. FALSE CEILING)',status:'IN PROGRESS',type:2},
        {title:'DOOR & WINDOW FRAMES, ELECTRICAL WIRING (WITHOUT FITTINGS), INTERNAL PLASTERING & PLUMBING',status:'IN PROGRESS',type:2},
        {title:'CAR PARK, ROADS AND DRAINS',status:'UPCOMING',type:0},
        {title:'T.O.P. ESTIMATED Q1 2027*',status:'UPCOMING',type:0},
    ]
    };
  },
  
  methods: {
    handleMouseEnter() {
      this.mouseType = true;
    },
    handleMouseLeave() {
      this.mouseType = false;
    },
    play() {
      this.$refs.video.play();
    },
    pause() {
      this.$refs.video.pause();
    },
    rewind() {
      this.$refs.video.currentTime -= 5; // 倒退5秒
    },
    fastForward() {
      this.$refs.video.currentTime += 5; // 快进5秒
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.home {
  width: 100%;
  height: calc(100vh + 56px);
  margin-top: -56px;
  .HomeConter {
    height: calc(100vh - 110px);
    background-image: url("~@/assets/208/_Novo RDR_Hero Shot_RGB_lr.jpg");
    background-size: cover;
    background-position-y: 78%;
    position: relative;
  }
  .HomeConter-title {
    font-size: 1.5rem;
    font-weight: 600;
    left: 57%;
    top: 35%;
    position: absolute;
    width: 350px;
    text-align: start;
    letter-spacing: 3px;

  }
  .controls{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    button{
      background-color: #faebd700;
      box-shadow: none;
      padding: 0;
      border: 0;
      margin: 0 4vw;
    }
  }
  .Introduce {
    background-color: #575252;
    padding-top: 20vh;
    padding-bottom: 50px;
  }

  .IntroduceConter {
    padding-bottom: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60%;
    margin: auto;
    .img-content {
      height: 20vw !important;
      width: 40vw !important;
    }
  }
  .right-type {
    flex-direction: row-reverse;
  }
      .CONSTRUCTION-PROGRESS{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 100px;
        margin-bottom: 100px;
        color: #fff;
        width: 75%;
        margin: 0 auto;
        .CONSTRUCTION-PROGRESS-title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 50px;
            background-color: #575252;
            font-weight: 600;
            // border-bottom: 1px solid #fff;
        }
        .CONSTRUCTION-PROGRESS-content{
            display: flex;
            justify-content: center;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            // height: 50px;
            min-height: 50px;
            padding: 10px 0;
            border-bottom: 1px solid #fff;
            text-align: start;
        }
        .CONSTRUCTION-PROGRESS-status{
            width: 20%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .status1{
                width: 20px;
                height: 20px;
                background-color: #fff;
                border-radius: 50%;
            }
            .status2{
                width: 5px;
                height: 5px;
                background-color: #a98b59;
                border-radius: 50%;
                border: 8px solid #fff;
            }
            .status3{
                width: 20px;
                height: 20px;
                border: 1px solid #fff;
                border-radius: 50%;
            }
            span{
                margin-left: 10px;

            }
        }

    }
}


@media (max-width: 900px) {
    .CONSTRUCTION-PROGRESS{
        width: 90% !important;
    }
    .CONSTRUCTION-PROGRESS-status{
        width: 40% !important;
        flex-direction: column;
    }
    .CONSTRUCTION-PROGRESS-status span{
        margin-left: 0;
    }
  .home{
    .HomeConter{
      height: 50vh;
      background-size: cover;
      background-position-y:0;
      background-position-x: center;
    }
    .HomeConter-title{
      left: auto !important;
    font-size:14px;
    right: 10%;
    top: 45%;
    width: 150px;
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);

  }

  .IntroduceConter{
    width: 100% !important;
    flex-direction: column-reverse !important;
  }
  .IntroduceConter .img-content {
      height: 40vw !important;
      width: 80vw !important;
    }
  .textEnd,.textStart{
    width: 85% !important;
    text-align: center !important;
    margin: auto;
  }
  .IntroduceConter h2{
  font-size: 15px;
  margin-top: 20px;
  margin-bottom: 0;
}
  .IntroduceConter p{
    width: auto !important;
    line-height: 20px !important;
    margin: 3px;
    font-size: 11px;
    letter-spacing: 0;
  }
  }

}
</style>













